/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { uniq } from 'underscore';
import UIFormControl from 'UIComponents/form/UIFormControl';
import SidebarFormControl from 'DesignEditorsUI/components/shared/sidebar/SidebarFormControl';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.errors.field.${key}`;

const moduleI18nKey = key => `DesignEditorsUI.customWidgetEditor.errors.module.${key}`;

export default class _class extends Component {
  render() {
    const _this$props = this.props,
          {
      errors,
      warnings,
      isModuleError
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["errors", "warnings", "isModuleError"]);

    const errorMessages = uniq(errors, ({
      type
    }) => type).map(({
      type,
      data
    }) => {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: isModuleError ? moduleI18nKey(type) : i18nKey(type),
        options: data
      }, type);
    });
    const warningMessages = uniq(warnings, ({
      type
    }) => type).map(({
      type,
      data
    }) => {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: i18nKey(type),
        options: data
      }, type);
    });
    return /*#__PURE__*/_jsx(SidebarFormControl, Object.assign({
      errors: errorMessages,
      warnings: warningMessages
    }, rest));
  }

}
_class.propTypes = {
  characterCount: UIFormControl.propTypes.characterCount,
  children: PropTypes.node,
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.object),
  warnings: PropTypes.arrayOf(PropTypes.object),
  isModuleError: PropTypes.bool
};
_class.defaultProps = {
  className: null,
  errors: [],
  warnings: [],
  isModuleError: false
};